/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import Icon from 'components/_particles/icon/react/Icon';
import IconLink from 'components/atoms/icon-link/react/IconLink';
import type { BurgerProps, NavigationItem } from '../types';
import Login from './Login';

const BurgerContentStart = ({
  setStepKey,
  setActiveItem,
  items,
  externals,
  languages,
  currentLanguage,
  loginProps,
  ministries,
  ministryDropdownName,
}: BurgerProps): React$MixedElement => {
  const handleOpen = (item: NavigationItem) => {
    setActiveItem(item);
    setStepKey('submenu');
  };

  return (
    <div className="burger__content">
      <nav className="burger__inner" aria-label={t('Detailliertes Menü')}>
        {ministries && ministries.length > 0 && (
          <button
            className="burger__select burger__select--subtle"
            onClick={() => setStepKey('ministry')}
            type="button"
          >
            {ministryDropdownName || t('Alle Ministerien')}
          </button>
        )}

        <div className="burger__nav">
          <ul className="burger__items" aria-label={t('Hauptnavigation')}>
            {items?.map((item, index) => (
              <li key={index} className="burger__item">
                {item.hasSubpages ? (
                  <button
                    className="icon-link"
                    type="button"
                    onClick={() => handleOpen(item)}
                  >
                    <span className="icon-link__text">{item.title}</span>
                    <span className="icon-link__button">
                      <Icon
                        icon="arrow-right-line"
                        className="icon-link__icon"
                      />
                    </span>
                  </button>
                ) : (
                  <a className="icon-link" href={item.link}>
                    <span className="icon-link__text">{item.title}</span>
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>

        <ul
          className="burger__secondary"
          aria-label={t('Weitere interne und externe Links und Funktionen')}
        >
          {externals &&
            externals.map((ext, i) => (
              <li key={i} className="burger__external">
                <IconLink
                  icon={ext.icon || 'external'}
                  link={ext.link}
                  large
                  external={ext.external}
                >
                  {ext.text}
                </IconLink>
              </li>
            ))}

          {loginProps && <Login {...loginProps} />}

          {currentLanguage && languages && languages.length > 0 && (
            <li className="burger__languages">
              <button
                className="burger__select"
                onClick={() => setStepKey('languages')}
                type="button"
              >
                {currentLanguage}
              </button>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default BurgerContentStart;
